import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { trackInitiateCheckout } from '../utils/metaPixel';
interface OfferSectionProps {
  orderBump1Selected: boolean;
  orderBump2Selected: boolean;
}
export function OfferSection({
  orderBump1Selected,
  orderBump2Selected
}: OfferSectionProps) {
  const basePrice = 6;
  const orderBump1Price = 9;
  const orderBump2Price = 9;
  const totalPrice = basePrice + (orderBump1Selected ? orderBump1Price : 0) + (orderBump2Selected ? orderBump2Price : 0);
  // Generate Shopify cart URL based on order bump selection
  const getCartUrl = () => {
    if (orderBump1Selected && orderBump2Selected) {
      // Both order bumps selected
      return 'https://jwmoka.shop/cart/46357134606507:1';
    } else if (orderBump1Selected) {
      // Only order bump 1 selected
      return 'https://jwmoka.shop/cart/46357127921835:1';
    } else if (orderBump2Selected) {
      // Only order bump 2 selected
      return 'https://jwmoka.shop/cart/46357131657387:1';
    } else {
      // No order bumps selected (base product only)
      return 'https://www.jwmoka.shop/cart/46286948335787:1';
    }
  };
  const handlePurchaseClick = () => {
    trackInitiateCheckout();
  };
  return <Section id="offer" className="px-6 md:px-12 max-w-4xl mx-auto" data-id="element-190">
      <div className="relative p-8 md:p-16 border border-[#b8860b]/30 bg-[#0a0a0a] text-center overflow-hidden" data-id="element-191">
        {/* Decorative background glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full max-w-md bg-[#d4a853]/5 blur-[100px] rounded-full pointer-events-none" data-id="element-192" />

        <div className="relative z-10 space-y-8" data-id="element-193">
          <h2 className="font-serif text-3xl md:text-5xl font-semibold text-gray-100 leading-tight" data-id="element-194">
            Dejá de ser el motor y <br className="hidden md:block" data-id="element-195" />
            <span className="text-[#f0c674]" data-id="element-196">convertite en el arquitecto.</span>
          </h2>

          <p className="font-sans text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-197">
            Obtené el Blueprint completo, los Workbooks y el sistema de
            Micro-Automatización hoy mismo.
          </p>

          <div className="py-8" data-id="element-198">
            <p className="font-mono text-sm text-gray-500 uppercase tracking-widest mb-2" data-id="element-199">
              Precio Lanzamiento
            </p>
            <div className="flex items-center justify-center space-x-2" data-id="element-200">
              <span className="font-mono text-5xl md:text-7xl font-bold text-[#d4a853] transition-all duration-300" data-id="element-201">
                ${totalPrice}
              </span>
              <span className="font-mono text-xl text-[#d4a853]/70 mt-4" data-id="element-202">
                USD
              </span>
            </div>
            <p className="font-sans text-sm text-gray-500 mt-2" data-id="element-203">(Pago único)</p>
          </div>

          <div className="max-w-md mx-auto" data-id="element-204">
            <Button fullWidth className="py-5 text-lg" href={getCartUrl()} onClick={handlePurchaseClick} data-id="element-205">
              Quiero mi Blueprint Ahora
            </Button>
            <p className="font-sans text-sm text-gray-500 mt-6 flex items-center justify-center space-x-2" data-id="element-206">
              <span className="w-2 h-2 rounded-full bg-green-500/50 animate-pulse" data-id="element-207" />
              <span data-id="element-208">Acceso inmediato tras el pago.</span>
            </p>
            <p className="font-serif text-gray-400 italic mt-2" data-id="element-209">
              Tu tiempo no vuelve, las automatizaciones sí.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}